/*This configuration is used in
    components/common/breakdownchart.jsx
    components/common/linechart.jsx
    components/common/rangechart.jsx
 */
export default {
    gui: {
        "behaviors": [
            {
                "id": "ViewSource",
                "enabled": "none"
            },
            {
                "id": "Reload",
                "enabled": "none"
            },
            {
                "id": "Print",
                "enabled": "none"
            },
            {
                "id": "DownloadSVG",
                "enabled": "none"
            },
            {
                id: "SaveAsImage",
                enabled: "all"
            }
        ],
        contextMenu: {
            button: {
                alpha: 0.1,
                borderRadius: 15,
                visible: true
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/charts/commonchartconfig.jsx